import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import DCAPortfolio360 from "./components/DCAPortfolio360";
import ParcoursOnboarding from "./components/ParcoursOnboarding";
import LanguageSelect from "./components/LanguageSelect";
import MyPortafolio from "./components/MyPortafolio";
import AdminPanel from "./components/AdminPanel";
import BotPerformanceHub from "./components/BotPerformanceHub";
import AuthCallback from "./components/AuthCallback";
import { AuthProvider } from "./hooks/useAuth";
import { Toaster } from "./components/ui/toaster";
import { AccessDenied, hasAccess } from "./components/AccessGate";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// Catch session_id in URL fragment BEFORE normal routing runs (prevents race conditions).
function AppRouter() {
  const location = useLocation();
  const [allowed] = React.useState(hasAccess);
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  if (!allowed) return <AccessDenied />;
  return (
    <Routes>
      <Route path="/" element={<DCAPortfolio360 />} />
      <Route path="/shared/:config" element={<DCAPortfolio360 />} />
      <Route path="/parcours" element={<ParcoursOnboarding />} />
      <Route path="/language" element={<LanguageSelect />} />
      <Route path="/myportafolio" element={<MyPortafolio />} />
      <Route path="/admin" element={<AdminPanel />} />
      <Route path="/bots" element={<BotPerformanceHub />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
